import { forwardRef, memo, type ReactNode, type Component } from 'react';
import clsx from 'clsx';
// Material UI imports
import CardActions, { type CardActionsProps } from '@mui/material/CardActions';
import Divider from '@mui/material/Divider';
// SCSS imports
import {
  footer, flexible, flexibleCompact, centered, centeredCompact, rightAligned, rightAlignedCompact, divider
} from './CardFooter.module.scss';

type CardFooterProps = {
  readonly withDivider?: boolean | null;
  readonly flex?: boolean | null;
  readonly compact?: boolean | null;
  readonly rightAlign?: boolean | null;
  readonly className?: string;
  readonly sx?: CardActionsProps['sx'];
  // React built-in
  readonly children?: ReactNode;
}

const CardFooter = forwardRef<Component<CardActionsProps>, CardFooterProps>(({
  children,
  withDivider = false,
  rightAlign = false,
  compact = false,
  flex = false,
  className,
  sx
}, ref) => (
  <>
    {withDivider ? <Divider className={divider}/> : undefined}
    <CardActions
        ref={ref}
        className={clsx(footer, {
          [flexible]: flex && !compact,
          [flexibleCompact]: flex && compact,
          [rightAligned]: !flex && rightAlign && !compact,
          [rightAlignedCompact]: !flex && rightAlign && compact,
          [centered]: !flex && !rightAlign && !compact,
          [centeredCompact]: !flex && !rightAlign && compact
        }, className)}
        sx={sx}
    >
      {children}
    </CardActions>
  </>
));

CardFooter.displayName = 'CardFooter';

export default memo(CardFooter);
